import { WhiteInstantSearchBuilder } from '@white-nl/instantsearch-components';
import Hit from './components/results/Hit/Hit';
import SortBy from '../components/SortBy';
import Pagination from '../components/Pagination';
import FilterSidebar from './components/refinements/FilterSidebar/FilterSidebar';
import BlogType from './components/refinements/BlogType/BlogType';

const whiteInstantSearchBuilder = new WhiteInstantSearchBuilder();
const blogOverview = document.getElementById('blog-overview');
const settings: DOMStringMap | null = blogOverview?.dataset || null;
const translatesUrl = settings?.translatesUrl;

if (blogOverview && settings && translatesUrl) {
  const {
    indexName,
    publicUrl,
    jwt,
    refreshUrl,
    baseUrl,
  } = settings;

  fetch(translatesUrl, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  }).then((res) => res.json())
    .then((translates) => {
      const { blogs } = translates;
      whiteInstantSearchBuilder
        .withSearchkit(
          indexName || '',
          publicUrl || '',
          jwt || '',
          refreshUrl || '',
        )
        .withWhiteInstantSearchRouting(
          {
            baseUrl,
            addTrailingSlashesToUrls: true,
          },
        )
        .addAdditionalData(
          {
            blogs,
          },
        )
        .addMenu(
          [
            {
              settings: {
                attribute: 'blogType',
                sortBy: ['name:asc'],
                limit: 10,
              },
              component: BlogType,
            },
          ],
        )
        .addSortByComponent(
          [
            {
              settings: {
                items: [
                  {
                    label: Craft.t(blogs, 'Datum (Recent naar oud)'),
                    value: indexName || '',
                  },
                  {
                    label: Craft.t('blogs', 'Datum (Oud naar recent)'),
                    value: `${indexName}_date_asc`,
                  },
                ],
              },
              component: SortBy,
            },
          ],
        )
        .registerContainer(
          FilterSidebar,
          '#white-instant-search-sidebar-refinements',
        )
        .addHitComponent(
          [
            {
              component: Hit,
            },
          ],
        )
        .addPaginationComponent(
          [
            {
              settings: {
                translations: {
                  nextPageItemAriaLabel: Craft.t(blogs, 'Volgende'),
                  previousPageItemAriaLabel: Craft.t(blogs, 'Vorige'),
                },
              },
              component: Pagination,
            },
          ],
        )
        .setHitsPerPage(12)
        .build()
        .show();
    });
}
